import { IconButton as CBIconButton, IconButtonVariant } from '@creditornot/cb-button';
import { cbSemanticCssVars } from '@creditornot/cb-ingredients';
import { Popover } from '@creditornot/cb-popover';
import React from 'react';
import styled from 'styled-components';

import { typographyCss } from 'common/typography';

type Props = {
  disabled?: boolean;
  disableEndMargin?: boolean;
  icon: React.ReactNode;
  iconButtonVariant?: IconButtonVariant;
  onClick: () => void;
  tooltipTitle: React.ReactNode;
};

const IconButton = styled(CBIconButton)<{ $disableEndMargin: boolean }>`
  margin-inline-end: ${props => (props.$disableEndMargin ? '0' : '16px')};
`;

const PopoverContent = styled.div`
  max-width: 240px;
  min-height: 30px;
  padding: 8px;
  ${typographyCss.Body3}
  color: ${cbSemanticCssVars.textPrimary};
`;

const ActionButton = ({
  disabled = false,
  disableEndMargin = false,
  icon,
  iconButtonVariant = 'black',
  onClick,
  tooltipTitle,
}: Props) => {
  return (
    <Popover
      content={<PopoverContent>{tooltipTitle}</PopoverContent>}
      placement="top"
      openOnHover
      openOnClick={false}
      offset={4}
    >
      {({ refProps }) => (
        <IconButton
          $disableEndMargin={disableEndMargin}
          disabled={disabled}
          size="small"
          variant={iconButtonVariant}
          {...refProps}
          onClick={e => {
            onClick();
            refProps.onClick?.(e);
          }}
        >
          {icon}
        </IconButton>
      )}
    </Popover>
  );
};

export default ActionButton;
